// ! rename the function to align with the widget name
export const teamCarousels = () => {

    const els = document.querySelectorAll('.curious-team-carousels');
    if (!els) return;

    // ------------------------------------------------------------


    els.forEach(teamMemberCarousel => {
        const swiper = teamMemberCarousel.querySelector('.team-member-swiper');
        const prev = document.querySelector('.team-member-prev');
        const next = document.querySelector('.team-member-next');
        console.log('Initializing Swiper for:', swiper, prev, next);
        // Use globally available Swiper (loaded from site.js entry point)
        const s = new window.Swiper(swiper, {
            modules: [window.SwiperModules.Navigation],
            direction: 'horizontal',
            slidesPerView: 'auto',
            // spaceBetween: 16,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
        });

    });

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

